package com.patronat.top.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
internal actual fun appIconPainter(
    resource: DrawableResource,
    androidResourceName: String?
): Painter = painterResource(resource)
